module.exports = __webpack_public_path__ + "img/second-bg-container.38c252f1.svg";